import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import GraphicEq from '@mui/icons-material/GraphicEq';
import MenuBook from '@mui/icons-material/MenuBook';
import HealthAndSafety from '@mui/icons-material/HealthAndSafety';
import Balance from '@mui/icons-material/Balance';
import { useTheme } from '@material-ui/core/styles';
import { readableHeading } from '../readablePalette';

const frentes = [
  {
    tag: '01 · Académico',
    Icon: MenuBook,
    text:
      'Especialización (LOPNNA, civil, mercantil) al servicio de las familias: conversaciones que elevan el estándar del asesoramiento.',
  },
  {
    tag: '02 · Previsión',
    Icon: HealthAndSafety,
    text: 'Salud y beneficios sociales para abogados al día: el gremio cuidando al gremio, en lenguaje claro para antena.',
  },
  {
    tag: '03 · Ética',
    Icon: Balance,
    text: 'Ejercicio ilegal, certificación y confianza ciudadana: por qué acudir a quienes respalda el Colegio.',
  },
];

const WaveBars = () => (
  <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.6, height: 44, opacity: 0.85 }}>
    {[8, 16, 10, 22, 14, 28, 12, 20, 9, 24, 15, 30, 11, 18].map((h, i) => (
      <Box
        key={i}
        sx={{
          width: 4,
          height: h,
          borderRadius: 1,
          bgcolor: 'rgba(196,164,93,0.85)',
          animation: `colegioBar 1.2s ease-in-out ${i * 0.08}s infinite alternate`,
          '@keyframes colegioBar': {
            '0%': { transform: 'scaleY(0.55)', opacity: 0.5 },
            '100%': { transform: 'scaleY(1)', opacity: 1 },
          },
        }}
      />
    ))}
  </Box>
);

const AntennaAndRadio = () => {
  const theme = useTheme();
  const h = readableHeading(theme);
  const deep = theme.palette.primary.main;
  const gold = theme.palette.secondary.main;

  return (
    <Box
      component="section"
      sx={{
        my: { xs: 5, md: 7 },
        py: { xs: 4, md: 6 },
        px: { xs: 2, sm: 3, md: 4 },
        borderRadius: { xs: 0, sm: 4 },
        position: 'relative',
        overflow: 'hidden',
        background:
          theme.palette.mode === 'dark'
            ? `linear-gradient(155deg, rgba(196,164,93,0.08) 0%, transparent 45%), linear-gradient(180deg, ${theme.palette.background.default} 0%, rgba(12,22,18,0.98) 100%)`
            : `linear-gradient(155deg, rgba(196,164,93,0.14) 0%, transparent 42%), linear-gradient(180deg, #f4f7f4 0%, #fff 50%)`,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          bottom: '-18%',
          left: '-8%',
          width: 'min(420px, 55vw)',
          height: 'min(420px, 55vw)',
          borderRadius: '50%',
          background: `radial-gradient(circle, rgba(27,51,38,0.12) 0%, transparent 68%)`,
          pointerEvents: 'none',
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { sm: 'flex-end' }, gap: 2, mb: 3 }}>
          <Box
            sx={{
              width: 4,
              minHeight: 52,
              borderRadius: 2,
              background: `linear-gradient(180deg, ${gold} 0%, ${deep} 100%)`,
              display: { xs: 'none', sm: 'block' },
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 0.5,
                borderRadius: 999,
                bgcolor: theme.palette.mode === 'dark' ? 'rgba(196,164,93,0.12)' : 'rgba(196,164,93,0.2)',
                border: `1px solid rgba(196,164,93,0.45)`,
                mb: 1.5,
              }}
            >
              <GraphicEq sx={{ fontSize: 18, color: gold }} />
              <Typography variant="caption" sx={{ fontWeight: 800, letterSpacing: '0.14em', color: gold }}>
                Antena · Radio Visual
              </Typography>
            </Box>
            <Typography
              variant="h4"
              component="h2"
              sx={{ fontWeight: 800, color: h, fontFamily: 'Georgia, serif', lineHeight: 1.2, maxWidth: 640 }}
            >
              Señal que se siente: voz del Colegio en familia
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} lg={5}>
            <Box
              sx={{
                height: '100%',
                borderRadius: 3,
                overflow: 'hidden',
                position: 'relative',
                border: `1px solid rgba(196,164,93,0.4)`,
                background: `linear-gradient(145deg, ${deep} 0%, ${theme.palette.primary.dark} 55%, #0a120e 100%)`,
                boxShadow: '0 24px 56px rgba(0,0,0,0.28)',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '55%',
                  height: '100%',
                  opacity: 0.12,
                  background: `radial-gradient(circle at 80% 20%, ${gold} 0%, transparent 55%)`,
                  pointerEvents: 'none',
                }}
              />
              <Box sx={{ position: 'relative', p: { xs: 2.5, sm: 3 } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="overline" sx={{ color: gold, fontWeight: 800, letterSpacing: '0.18em' }}>
                    Micro · referencia
                  </Typography>
                  <WaveBars />
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    color: 'rgba(255,255,255,0.92)',
                    fontStyle: 'italic',
                    lineHeight: 1.75,
                    fontSize: '1.05rem',
                    fontFamily: 'Georgia, "Times New Roman", serif',
                  }}
                >
                  «¿Sabes quién respalda tu ejercicio profesional? El Colegio de Abogados del Distrito Capital es tu casa,
                  tu formación y tu defensa. Únete a una comunidad de ética y excelencia. Un mensaje del Ilustre Colegio de
                  Abogados en <Box component="span" sx={{ color: gold, fontWeight: 700, fontStyle: 'normal' }}>Legalmente en Familia</Box>, por TNO
                  Network.»
                </Typography>
                <Box
                  sx={{
                    mt: 2.5,
                    pt: 2,
                    borderTop: '1px solid rgba(196,164,93,0.25)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      border: `2px solid ${gold}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: gold }} />
                  </Box>
                  <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.5 }}>
                    Listo para rotación en bloques cortos: tono institucional sin perder cercanía con el hogar.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} lg={7}>
            <Typography variant="overline" sx={{ color: gold, fontWeight: 800, letterSpacing: '0.16em', display: 'block', mb: 1.5 }}>
              En el programa
            </Typography>
            <Grid container spacing={2}>
              {frentes.map(({ tag, Icon, text }) => (
                <Grid item xs={12} sm={4} key={tag}>
                  <Box
                    sx={{
                      height: '100%',
                      p: 2,
                      borderRadius: 2.5,
                      border: `1px solid rgba(196,164,93,0.35)`,
                      bgcolor: theme.palette.mode === 'dark' ? 'rgba(21,37,30,0.75)' : 'rgba(255,255,255,0.92)',
                      boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 10px 32px rgba(27,51,38,0.06)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      position: 'relative',
                      overflow: 'hidden',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 3,
                        background: `linear-gradient(90deg, ${gold}, ${deep})`,
                      },
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: theme.palette.mode === 'dark' ? '0 16px 40px rgba(0,0,0,0.35)' : '0 16px 40px rgba(27,51,38,0.1)',
                      },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.25 }}>
                      <Typography variant="caption" sx={{ fontWeight: 800, color: deep, letterSpacing: '0.06em' }}>
                        {tag}
                      </Typography>
                      <Icon sx={{ fontSize: 26, color: gold, opacity: 0.95 }} />
                    </Box>
                    <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.65 }}>
                      {text}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AntennaAndRadio;
